import React from 'react'
import { Button, CenteredSpinner, Row } from 'react-angle-dashboard-components'
import { useHistory } from 'react-router-dom'
// import { ISelectablePlan } from '../../interfaces/plan'
import { Paths } from '../../routes/paths'
import { RightCol, LeftCol, TotalCostText } from './styles'

export const MainCostsSection: React.FC<{
  totalEmployerCost: number | undefined
  isLoading: boolean
}> = ({ totalEmployerCost, isLoading }) => {
  const history = useHistory()

  return (
    <Row className="bg-white d-flex">
      <LeftCol xs={12} sm={6}>
        {isLoading ? (
          <CenteredSpinner />
        ) : (
          <>
            {' '}
            <p style={{ fontSize: 25 }}>Your total employer contribution</p>
            <span className="fs-20">Estimated</span>
            <TotalCostText>
              $<span>{totalEmployerCost}</span>/mo
            </TotalCostText>
            {/* TODO: add back in when I have this on BE */}
            {/* <CostSubWrapper>
              <span>Employees</span>
              <CostSubtext>${employeesCost.toLocaleString()}</CostSubtext>
            </CostSubWrapper>
            <CostSubWrapper>
              <span>Dependents</span>
              <CostSubtext>${dependentsCost.toLocaleString()}</CostSubtext>
            </CostSubWrapper> */}
          </>
        )}
      </LeftCol>
      <RightCol xs={12} sm={6}>
        <p className="fs-20 pb-3">
          We've calculated your estimated costs based on your plan selection(s),
          employee information, and employer contribution amounts. Final costs
          may vary depending on enrollment and employee elections.
        </p>
        <Button
          className="px-4"
          onClick={() => history.push(Paths.companyCensus)}
        >
          Begin Onboarding
        </Button>
      </RightCol>
    </Row>
  )
}
